export default "__VITE_ASSET__DdDjNag8__"